export default __webpack_public_path__ + "static/media/diagramDNS.33fe8cb0.png";